import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';

import _cookie from "../../assets/js/cookie";
import jsonp from "../../assets/js/http";
import { Component, Vue } from "vue-property-decorator";
import luckDraw from "../../theme/components/luckDrawModal/luckDraw.vue";
import shareData from "./components/shareData/shareData.vue";
import addGoods from "../../theme/components/addGoodsModal/addGoodsModal.vue";
import orderList from "./components/orderManageModal/orderList/orderList.vue";
import classList from "@/views/broadHost/components/customClassification/index.vue";
import invitionCode from "@/views/broadHost/components/isInvitationCode/index.vue";
import seckillModal from "./components/seckillModal/seckillModal.vue";
import usqManage from "./components/usqManage/usqManage.vue";
import blessingBag from "./components/blessingBag/blessingBagList/blessingBagList.vue";
import couponList from "./components/couponModal/couponModal.vue";
import getJob from "./components/getJob/index.vue";
import "../../assets/css/tip.scss";
import { Debounced } from '../../assets/js/utils'
import _com from "../../assets/js/common";
import _intercept from "@/assets/js/intercept";

@Component({
	components: {invitionCode, luckDraw, addGoods, 'popper': Popper, shareData, orderList, seckillModal, couponList, blessingBag,classList,usqManage,getJob },
})
export default class broadHost extends Vue {
	// private debounceStart: Function = new Debounced().use(this.startFilmed, 1000);
	private debounceLottoryFree: Function = new Debounced().use(this.toFreeOrder, 1000);
	get videoStatus() {
		let data = this.$store.getters["getRoomDetail/getStatus"];
		if (this.isRecording) {
			data.tvStatus = 1
		}
		if (data.roomStatus == "1" && data.tvStatus == 0) {
			//断流
			this.m3u8Timer = setTimeout(() => {
				this.getHls();
			}, 5000);
		} else if (data.roomStatus == "1" && data.tvStatus == 1) {
			//直播中
			if (this.roomData.live_status == 0) {
				//待开播转开播
				this.roomData.live_status = data.roomStatus;
				this.duration++;
				this.getHls();
			}
			//this.showPoster=true;
		} else if (data.roomStatus == "0" || data.roomStatus == "2") {
			//0未开播  2关播
		}
		return data;
	}
	get people() {
		//房间观众数
		return this.$store.getters["timing/getPeople"];
	}
	get likeNum() {
		return this.$store.getters["timing/getLike"];
	}
	get hotGoodLists() { // 获取直播间爆款商品列表
		return this.$store.getters["refresh/getHotGoodList"]
	}
	isRecording = false  //是否录播
	recordHsl = '' //录播地址
	isVideo = false //是否设置开播地址
	peopleAll = 0
	isDownLoad = false
	loadingText = "";
	isShowLoading: boolean = false; //是否显示loading
	roomData: any = {
		goods: [],
	}; //直播间数据
	isquery: boolean = false //是否正在请求直播地址
	api: any = {
		goodsCategoryAll: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/goodsCategory/queryAll/", //直播中控台-自定义分类列表查询
		goodsCategory: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/goodsCategory/query/", //直播中控台-自定义分类查询
		addGoodsCategory: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/goodsCategory/add", //直播中控台-新增自定义分类
		deleteCustom: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/goodsCategory/delete/", //直播中控台-删除自定义分类
		modifyGoodsCategory: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/goodsCategory/update", //直播中控台-修改(更新)自定义分类
		setHotGoods: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/hotGoods/setHotGoods", //设置直播间爆款商品
		getHotGoods: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/hotGoods/query",  // 查询爆款商品

		// process.env.VUE_APP_URI_CDNDOMAIN
		boomDetailApi: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/info", //直播间详情API
		getPeopleCountApi: process.env.VUE_APP_URI_CDNDOMAIN + '/live/api/out/room/count/', //获取直播间观众人数
		getAllPeopleCountApi: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/follow/total", //获取直播间累计关注人数
		getDownStatusApi: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/follow/down/status", //获取下载明细状态
		getDownDataApi: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/follow/down/data", //获取下载明细数据
		sendBarrageApi: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/barrage/submit", //主播回复消息
		getBarrage: process.env.VUE_APP_URI_CDNDOMAIN + "/ulelivebarrage/api/v1/barrage/static/list", //获取弹幕信息
		recommend: "//pub" + this.domain + "/ulelivebarrage/api/v1/room/explain/submit", //推荐商品  ---初始
		// recommend: "https://pub.beta.ule.com/ulelivebarrage/api/v1/room/explain/submit", //推荐商品  ---测试
		// recommend: "//pub" + this.domain + "/ulelivebarrage/api/v1/room/good/explain", //推荐商品
		updateGoods: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/good/list", //更新商品
		getLike: process.env.VUE_APP_URI_CDNDOMAIN + "/ulelivebarrage/api/v1/room/static/like", //获取点赞数
		getStatus: process.env.VUE_APP_URI_CDNDOMAIN + "/live/api/out/room/status/", //获取直播间状态
		getM3u8: "//pub" + this.domain + "/live/api/out/play/room",
		setCoupon: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/coupon/change", // 设置优惠券
		setNotice: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/notice/change", // 设置公告
		getLuckyList: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/luck/list", // 抽奖记录
		changePlay: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/zhuBoStatus", //切换直播
		refresh: "https://opc" + process.env.VUE_APP_URI_DOMAIN + "/ule-live-amdin/api/v1/room/info/refresh",//刷新房间信息接口
		shareDetail: "https://opc" + process.env.VUE_APP_URI_DOMAIN + "/ule-live-amdin/api/v1/room/share/top",//分享明细
		forbid: "https://opc" + process.env.VUE_APP_URI_DOMAIN + "/ule-live-amdin/api/v1/room/msg/forbid",//用户禁言、取消禁言
		followCard: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/follow/card/auto", // 关注卡片自动提示开关设置
		pushFollowCard: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/follow/card/push", // 手动推送关注卡片
		productHidden: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/good/hidden",//商品显示隐藏
		roomScene: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/scene",//查询是否有未开播,直播中的场次
		posterSubmit: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/poster/submit",//上传海报接口
		goodRecord: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/good/record",//录制/取消录制视频接口、直播商品录制列表查询
		redRainOpen: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/red_rain/open",//红包雨活动开启接口
		lotteryDaily: "https://opc" + this.domain + "/ule-live-amdin/api/lottery/919/daily",//919电商节直播抽免单--查询当日抽奖信息
		lotteryFire: "https://opc" + this.domain + "/ule-live-amdin/api/lottery/919/fire",//919电商节直播抽免单–当日开奖
	};
	isGoodsList: boolean = false;
	duration: any = 0; // 播放时长
	timeInter: any = null;
	timeInterMsg: any = null;
	m3u8Timer: any = null;
	msgData: any = []; //弹幕数据
	last_id: Number = 0;
	msgNum: any = 0;
	isTouch: boolean = false; //鼠标悬停
	unreadNum: number = 0; //未读消息
	explainGoods: any = {}; //正在讲解商品
	controlArr: Array<string> = ["互动", "营销"];
	//controlIndex: Number = 0;
	luckDraw: boolean = false; //抽奖设置弹窗
	addGoodsModal: boolean = false; //添加商品弹窗
	setCouponModal: boolean = false; //添加优惠券弹框
	couponListModal: boolean = false; //优惠券列表弹框
	CouponBatchId: string = ""; //优惠券批次号
	setNoticeModal: boolean = false; //设置公告弹框
	noticeCont: string = ""; //公告文案
	luckyListModal: boolean = false; //抽奖记录弹框
	luckyList: Array<object> = []; //抽奖记录列表
	shareRoom: boolean = false; //分享房间
	roomLink: string = ""; //分享链接
	openLive: boolean = false; //直播开启弹框
	OBSLink: string = ""; //OBS链接
	sshLink: string = ""; //OBS串流密钥
	openShare: boolean = false;
	openUser: boolean = false;
	refreshData: any = {
		forbids: []
	};
	shareData: any = {};
	checkNum: number = 0;
	allCheck: boolean = false;
	checkedIds: any = [];
	isShowAttentionSet: boolean = false // 关注卡片设置弹框
	isOpenAttention: boolean = true // 是否开启关注
	isPushCanClick: boolean = true // 手动推送是否可以点击
	isClick: boolean = true // 按钮是否可以点击
	rulesTxt: string = '统计规则：<br>1、从直播场次创建成功开始统计到直播结束结束统计<br>2、按下单并支付成功订单计算<br>3、数据每五分钟更新1次';
	isShareData: boolean = false // 分享内容设置弹框
	isShowPosterSet: boolean = false // 生成海报设置弹框
	isOrderManage: boolean = false // 是否显示订单管理弹窗
	isSeckillManage: boolean = false // 是否显示秒杀管理弹窗
	usqManage: boolean = false // 是否显示优鲜活动管理弹窗
	isBlessingBagManage: boolean = false // 是否显示福袋管理弹窗
	posterUrl: any = null
	closeIcon: any = require("../../assets/img/poster-poup-close.png")
	auditStatusText: any = "提交审核"
	posterInfo: any = null
	uploadInfo: any = null//待上传图片
	isDesabled: boolean = true;
	inputContent: any = ''//主播输入框消息
	isShowTuiliu: boolean = false;
	filmedText: String = '';//视频录制按钮文案
	// filemdTime:any=0;//视频录制时长
	timeOutTimer: any = null//定时器
	setHbModal: Boolean = false;//红包雨弹框
	setHbCode: String = '';//红包雨活动code
	setFreeModal: Boolean = false;//抽免单状态
	freeNums: any = null;//抽免单人数
	difference: any = 0;//当前时间与服务器时间差
	isShowLottoryFree: Boolean = false;//是否显示抽免单按钮
	lottoryFreeInfo: any = null;//抽免单活动信息
	isExplosives: Boolean = false
	explosivesList: any = { hotGoodsList: [] }    // 选中的爆品
	isAvailable: Array<Boolean> = [] // 输入框是否可用
	sortList: any = {}    // 排序列表
	className: String = ''
	getAvailableRes:any
	isClassification: boolean = false // 自定义分类弹框
	classificationList: Array<any> = []    // 自定义分类列表
	isAshRecording:Boolean=false
	waitFor:String = '视频录制'
	recordingComplete:String = ''
	stopClick:Boolean = false   // 阻止重复点击
	isGetJob:Boolean = false //是否显示劳务招聘弹框
	isInvitationCode: boolean = false
	baseld:any
	mounted() {
		this.init();
		// this.initLottoryFree();//初始化查询一次抽免单信息接口
		_com.systemTime((difference: number) => {
			this.difference = difference
		})
	}
	init() {
		this.getLivePeopleCount(); //获取人数  直播状态
		this.getRoomDetail(); //房间详细
		this.getLike(); //获取喜欢数
		this.updateRefreshInfo();
		this.getAllPeople()
		let timeNum = 0;
		clearInterval(this.timeInter);
		this.timeInter = setInterval(() => {
			//定时 
			timeNum++;
			if (this.duration > 0) {
				this.duration++;
			}
			if (timeNum % 5 == 0) {
				//5秒获取一次弹幕
				this.getBarrage();
				this.getLike();
				this.getStatus();
				this.updateRefreshInfo();
			}
			if (timeNum % 30 == 0) {
				//30秒获取累计观众人数
				this.getAllPeople()
			}
			if (timeNum % 10 == 0) {
				//十秒钟调用一次抽免单信息查询接口
				// this.initLottoryFree()
			}
			if (timeNum % 300 == 0) {
				timeNum = 0;
			}

		}, 1000);
		this.msgScroll();
	}

	//打开分享弹框
	openShareFn() {
		this.shareDetail(() => {
			this.openShare = true;
		})
	}

	//关闭优惠券弹窗
	closeCouponModal() {
		this.couponListModal = false
	}

	// 自动推送关注卡片设置
	attention() {
		this.fetch({
			url: this.api.followCard,
			data: {
				room_id: this.$route.params.id,
				flag: this.isOpenAttention,
			}
		}).then((res: any) => {
			if (res.flag == -1) {
				this.isOpenAttention = !this.isOpenAttention
				this.$toast("你还未创建直播，请先创建直播场次")
			} else {
				this.$toast("设置成功")
			}
		})
	}
	addListData(data:any){  // 提交添加的列表
		this.fetch({
			url: this.api.addGoodsCategory,
			data,
			method: "post",
			noQS: true,
			formJson: true,
			arrayFormat: 'repeat',
			timeout: 30000
		}).then((data: any) => {
			this.$toast('添加成功')
			this.isClassification = false
		}, (err: any) => {
			this.$toast(err.data)
		})
	}
	
	deleteItem(data:any){ // 删除分类列表
		this.fetch({
            url: this.api.deleteCustom + data.sceneId + '/' + data.id,
            method: "post",
            noQS: true,
            formJson: true,
            arrayFormat: 'repeat',
            timeout: 30000
        }).then(() => {
			this.classificationList = this.classificationList.filter((item:any)=> data.id != item.id)
            this.$toast('已删除此分类！')
        }, (err: any) => {
            this.$toast(err.data)
        })
	}
	
	modifyList(datas:any){  // 更新分类列表
		let list_ids =  datas.listIds
		const data = {
			room_id: Number(this.$route.params.id),
			category_name: datas.name,
			id: datas.id,
			list_ids,
		}
		this.fetch({
			url: this.api.modifyGoodsCategory,
			data: data,
			method: "post",
			noQS: true,
			formJson: true,
			arrayFormat: 'repeat',
			timeout: 30000
		}).then((data: any) => {
			this.$toast('已更新分类列表')
			this.isClassification = false

		},(err:any)=>{
			this.$toast(err.data)
		})
	}
	setGoods(item: any, bool: boolean) {
		item.isListShow = bool;
		this.$forceUpdate();
	}
	explosivesSort(sort: Object, commodityItem: any): void { // 设置爆款排序

	}
	activeExplosives(activeData: any, activeInx: any): void { // 设置爆款数据
		let activeList = this.explosivesList.hotGoodsList
		if (!this.isAvailable[activeInx]) {
			activeList.push({
				listId: activeData.listId
			})
		} else {
			let sortList = this.sortList
			let detExpenditures: number = activeList.findIndex((item: any) => {
				return item.listId == activeData.listId
			})
			activeList.splice(detExpenditures, 1)
			sortList[activeData.listId] = ''
			this.sortList = sortList
		}
		this.explosivesList.hotGoodsList = activeList
		this.isAvailable[activeInx] = !this.isAvailable[activeInx]
	}
	preservation() {  // 提交爆款列表
		let sortList = this.sortList
		let isAvailable = this.isAvailable
		let roomDataGoods =  this.roomData.goods
		let newData:any = {
			roomId:this.$route.params.id,
			sceneNum : this.roomData.scene_id,
			hotGoodsList:[]
		}
		roomDataGoods.forEach(((goodsItem:any,goodsInx:number)=>{
			if(isAvailable[goodsInx]){
				newData.hotGoodsList.push({
					listId:goodsItem.listId,
					sortNum:String(sortList[goodsItem.listId])
				})
			}
		}))
		let obj:any = {}
		let duplicate = newData.hotGoodsList.reduce(function (item:any, next:any) {
			obj[next.sortNum] ? '' : obj[next.sortNum] = true && item.push(next)
			return item
		}, [])
		if(duplicate.length != newData.hotGoodsList.length) return this.$toast('设置的排序不能有重复！！！')
		this.fetch({
			url: this.api.setHotGoods,
			data: newData,
			method: "post",
			noQS: true,
			formJson: true,
			timeout: 30000
		}).then((data: any) => {
			this.isExplosives = false
			this.$toast('已设置爆款排序')
		})
	}

	setExpenditures() {  // 设置爆款列表
		let callback = "callback";
		jsonp(`${this.api.getHotGoods}/${this.$route.params.roomNumber}/${this.roomData.scene_id}/callback`, {
			jsonpcallback: callback,
		}).then((res: any) => {
			if(res.code == '0000'){
				this.isAvailable.forEach((availableItem:any,availableInx:number)=>{
					this.isAvailable[availableInx] = false
				})
			}else{
				this.getAvailableRes = res
				res.forEach((resItem:any)=>{
					this.sortList[resItem.listId] = resItem.sortNum
				})
				this.roomData.goods.forEach((goodsItem:any,goodsInx:number)=>{
					this.isAvailable[goodsInx] = this.sortList[goodsItem.listId] > 0
				})
			}
		})
	}
	//商品隐藏显示click
	hiddenClick(type: number, listId: string) {
		this.fetch({
			url: this.api.productHidden,
			data: {
				room_id: this.$route.params.id,
				good_id: listId,
				hidden: type
			}
		}).then((res: any) => {
			this.updateGoods();
		}, (err: any) => {
			if (err.msg) {
				this.$toast(err.msg)
			}
		});
	}

	// 手动推送关注卡片
	pushAttention() {
		this.fetch({
			url: this.api.pushFollowCard,
			data: {
				room_id: this.$route.params.id
			}
		}).then((res: any) => {
			this.$toast("推送成功")
		}).catch((res: any) => {
			if (res.code == '20001') {
				this.$toast(res.data)
			} else {
				this.$toast(res.msg)
			}
		})
	}

	// controlChange(index: number) {
	// 	this.controlIndex = index;
	// }
	setPrize(val: boolean) {
		//设置抽奖
		// if (this.roomData.live_status != 1) {
		// 	this.$toast({
		// 		message: "请先开播",
		// 		className: "topIndex",
		// 		duration: 2000,
		// 	});
		// 	return false;
		// }
		this.luckDraw = val;
	}
	addGoodsSet(val: boolean) {
		//添加商品
		this.addGoodsModal = val;
	}
	updateGoods() {
		//更新商品
		this.fetch({
			url: this.api.updateGoods + "?room_id=" + this.$route.params.id,
			data: {},
			method: "GET",
		}).then((data: any) => {
			this.roomData.goods = data;
		});
	}

	updateRefreshInfo() {//刷新房间信息接口
		this.fetch({
			url: this.api.refresh + "?room_id=" + this.$route.params.id,
			method: "get",
		}).then((data: any) => {
			for (let i = 0; i < data.forbids.length; i++) {
				if (this.checkedIds.indexOf(data.forbids[i].user_id) >= 0) {
					data.forbids[i].check = true;
				} else {
					data.forbids[i].check = false;
				}
			}
			this.refreshData = data;
			this.roomData.goods = data.goods;//更新商品列表信息
			//设置海报地址
			if (!this.uploadInfo) {
				//存在本地预览图片时不更新显示图片
				this.posterUrl = data.poster.poster_pic_url ? data.poster.poster_pic_url.replace(/http:/, "https:") : null;
				this.auditStatusText = data.poster.audit_status ? this.filterStatus(data.poster.audit_status) : "提交审核";
			}
			this.posterInfo = data.poster.poster_pic_url ? data.poster : null;
		});
	}

	isEstoppel(userId: string) {
		let val = false;
		for (let i = 0; i < this.refreshData.forbids.length; i++) {
			let item = this.refreshData.forbids[i];
			if (userId == item.user_id) {
				val = true;
				return val;
			}
		}
		return val;
	}

	estoppel(id: string, time?: any) {
		let text;
		if (time == 0) {
			text = '确定对该些用户取消禁言？';
		} else {
			text = '是否禁言该用户？';
		}
		window.vant.Dialog.confirm({
			message: text,
		}).then(() => {
			this.fetch({
				url: this.api.forbid,
				data: {
					room_id: this.$route.params.id,
					user_ids: id,
					shut_up_time: time == 0 ? time : ""
				},
				method: "post",
			}).then((data: any) => {
				this.updateRefreshInfo();
				if (time != 0)
					this.$toast("禁言成功");
			}).catch((data: any) => {
				this.$toast(data.data);
			});
		});
	}

	moreEstoppel() {
		let ids = '';
		for (let i = 0; i < this.checkedIds.length; i++) {
			ids += this.checkedIds[i] + ',';
		}
		this.estoppel(ids, 0)
	}

	classificationName(data: any): void { // 设置分类名称
		if (data.target.value.length > 10) {
			this.$toast('分类名称最多只能输入10个字符！！！')
		}
	}
	change(item: any) {
		if (this.checkedIds.indexOf(item.user_id) == -1) {
			this.checkNum++;
			this.checkedIds.push(item.user_id);
		} else {
			this.checkNum--;
			let index = this.checkedIds.indexOf(item.user_id);
			this.checkedIds.splice(index, 1);
		}
		if (this.checkNum == (this.checkedIds.length) && this.checkNum != 0) {
			this.allCheck = true;
		} else {
			this.allCheck = false;
		}
	}

	allChange() {
		if (this.checkNum == (this.checkedIds.length)) {
			this.checkedIds = [];
			this.setCheck(true);
		} else {
			this.checkedIds = [];
			this.setCheck(false);
		}
	}

	setCheck(bool: boolean) {
		for (let i = 0; i < this.refreshData.forbids.length; i++) {
			this.refreshData.forbids[i].check = bool;
			if (bool)
				this.checkedIds.push(this.refreshData.forbids[i].user_id);
		}
	}

	shareDetail(callback: any) {//获取分享明细
		this.fetch({
			url: this.api.shareDetail + "?room_id=" + this.$route.params.id,
			method: "get",
		}).then((data: any) => {
			this.shareData = data;
			callback();
		});
	}


	getStatus(hlsURL?: any) {
		let url = `${this.api.getStatus}${this.$route.params.roomNumber}/roomStatus?t=${new Date().getTime()}`
		jsonp(url, {
			jsonp: "roomStatus",
			jsonpcallback: 'roomStatus'
		}).then(
			(data: any) => {
				if (this.isRecording) {
					data.tvStatus = 1
				}
				this.$store.dispatch("getRoomDetail/getStatusAsync", data);
				if (this.isRecording && data.roomStatus == "1") {
					if (this.recordHsl && !this.isVideo) {
						console.log('this.recordHsl', this.recordHsl);

						this.setVideo(this.recordHsl);
					}
				} else if (data.roomStatus == "1" && data.tvStatus == 1 && hlsURL) {
					this.getHls();
				}
			}
		);
	}
	getHls() {
		if (this.isquery) {
			return false
		} else {
			this.isquery = true
		}
		jsonp(this.api.getM3u8, {
			roomName: this.$route.params.roomNumber,
			durationInSeconds: 1800000,
			jsonp: "callback",
		}).then((data: any) => {
			setTimeout(() => {
				this.isquery = false
			}, 1000);
			data.hlsURL = (data.hlsURL || "").replace("http:", "").replace("https:", "");
			this.$store.dispatch("environment/getHlsAsync", data.hlsURL);
			this.setVideo(data.hlsURL);
		}).catch(() => {
			setTimeout(() => {
				this.isquery = false
			}, 1000);
		});
	}
	msgScroll() {
		if (this.isTouch) {
			return false;
		}
		clearInterval(this.timeInterMsg);
		let msg: any = this.$refs.msg;
		let timer: any = null;
		this.timeInterMsg = setInterval(() => {
			//1秒滚动一次弹幕
			let step = msg.children[0].children[0] ? msg.children[0].children[0].offsetHeight + 10 : 38;
			clearInterval(timer);
			let time = 0;
			timer = setInterval(() => {
				time++;
				if (time > step) {
					clearInterval(timer);
				} else {
					msg.scrollTo(0, msg.scrollTop + 1);
				}
			}, 16);
			if (msg.scrollTop + msg.clientHeight < msg.scrollHeight) {
				this.msgNum++;
			} else {
				clearInterval(this.timeInterMsg);
			}
		}, 800);
	}
	scrollBottom() {
		let msg: any = this.$refs.msg;
		msg.scrollTo(0, msg.scrollHeight);
		this.unreadNum = 0;
		this.isTouch = false;
	}
	mouseenter() {
		clearInterval(this.timeInterMsg);
		this.isTouch = true;
	}
	mouseleave() {
		this.isTouch = false;
		this.msgScroll();
	}
	getRoomDetail() {
		//获取直播间信息
		this.fetch({
			url: this.api.boomDetailApi + "?room_id=" + this.$route.params.id,
			data: {},
			method: "GET",
			timeout: 30000
		}).then((data: any) => {
			if (!data.goods) data.goods = [];
			if (data.scene_type == 2) {
				this.isRecording = true;
			}
			data.hlsURL = (data.hls_url || "").replace("http:", "").replace("https:", "");
			this.recordHsl = data.hlsURL
			this.getStatus(data.hlsURL);
			data.goods = data.goods.sort((a: any, b: any) => {
				return a.listAsc > b.listAsc ? 1 : -1;
			});
			this.isAvailable = Array(data.goods.length).fill(true) // 创建可选商品禁用状态列表
			let sortList = this.sortList
			// let isClassCommodity = this.isClassCommodity
			data.goods.forEach((goodsItem: any) => {  // 创建可选商品初始排序状态列表
				sortList[goodsItem.listId] = ''
				// isClassCommodity[goodsItem.listId] = true
			})
			this.roomData = data;
			this.baseld = data.scene_id
			this.setExpenditures()
			this.isOpenAttention = !!data.auto_follow
			this.duration = data.system_time - data.start_time || 0;
			// this.setVideo(data.hlsURL)
			this.noticeCont = data.notice || "";
			this.CouponBatchId = data.coupon || "";
			this.roomLink = data.tv_base || "";
			this.OBSLink = data.rtmp_url || "";
			this.sshLink = data.rtmp_token || "";
			this.getBarrage(); //获取弹幕
		});
	}
	setVideo(hlsURL: string) {
		this.isVideo = true
		//设置video播放路径
		this.$nextTick(() => {
			let Hls = (<any>window).Hls;
			let video: any = document.getElementById("video");
			if (Hls.isSupported()) {
				let hls = new Hls();
				hls.loadSource(hlsURL);
				hls.attachMedia(video);
				hls.on(Hls.Events.MANIFEST_PARSED, () => {
					video.play();
				});
			} else if (video.canPlayType("application/vnd.apple.mpegurl")) {
				video.src = hlsURL;
				video.addEventListener("loadedmetadata", () => {
					video.play();
				});
				video.addEventListener("play", () => {
					clearInterval(this.m3u8Timer);
					console.log("进入播放");
				});
			}

			video.addEventListener("error", (e: any) => {
				if (this.isRecording) {
					return false
				}
				console.log("错误方法:" + JSON.stringify(e));
				this.getHls();
			});

			video.addEventListener("durationchange", () => {
				console.log(video.duration);
			});
		});
	}
	getBarrage() {
		//获取直播间弹幕
		let callback = "getBarrage";
		let url = `${this.api.getBarrage}/${this.$route.params.roomNumber}/${Math.floor(new Date().getTime() / 5000)}/` + callback + '?t=' + new Date().getTime();
		jsonp(url, {
			jsonpcallback: callback,
		}).then((res: any) => {
			if (res.datas && res.datas.length > 0 && res.datas[res.datas.length - 1].id > this.last_id) {
				for (let i = 0, len = res.datas.length; i < len; i++) {
					const msg = res.datas[0];
					if (this.last_id >= msg.id) {
						res.datas.shift();
					}
				}
				if (res.datas.length > 0) {
					this.last_id = res.datas[res.datas.length - 1].id;
					this.msgData = this.msgData.concat(res.datas);
					if (this.msgData.length > 100) {
						this.msgData.splice(0, (this.msgData.length - 100));
					}
					this.msgScroll();
				}
			}
		});
	}
	sendBarrage() {
		if (!_intercept()) {
			return false;
		}
		if (this.roomData.live_status != 1) {
			this.$toast({
				message: "直播还未开始喲，发言暂时不会展示在直播间呢",
				className: "topIndex",
				duration: 2000,
			});
			return false;
		}
		if (!this.inputContent) {
			return false
		}
		//发送直播间弹幕
		this.fetch({
			url: this.api.sendBarrageApi,
			data: {
				room_name: this.$route.params.roomNumber,
				content: this.inputContent,
			},
		}).then(
			(data: any) => {
				console.log('发送成功');
				this.inputContent = ''
				this.getBarrage()
			},
			(data: any) => {
				let txt = '';
				if (data.code == 10000) this.clearStorage('用户信息过期')
				switch (data.code) {
					case "30000":
						txt = "检测到您的发言有敏感词，请重新输入";
						break;
					case "10000":
						txt = "用户信息过期";
						break;
					case "10001":
						txt = "你已被主播禁言。被禁言的用户不能发送发言";
						break;
				}

				if (txt != "") {
					this.$toast({
						message: txt,
						className: "topIndex",
						position: "bottom",
						duration: 2000,
					});
				}

			}
		);
	}
	clearStorage(msg?: any) {
		localStorage.clear();
		sessionStorage.clear();
		var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
		if (keys) {
			for (var i = keys.length; i--;) {
				document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();
				document.cookie = keys[i] + '=0;path=/;domain=' + this.domain + ';expires=' + new Date(0).toUTCString();
			}
		}
		this.$toast({
			message: msg ? msg : "您的账号未绑定手机号，请前往“个人中心/个人资料”中进行绑定！",
			duration: 2000,
			onClose: function () {
				if (!_intercept()) {
					return false;
				}
			}
		})
	}
	keydown(e: any) {
		//点击键盘发送
		if (e.keyCode == "13") {
			this.sendBarrage();
		}
	}
	getLivePeopleCount(time?: string) {
		//房间观众数
		setTimeout(() => {
			let callback = "people";
			let url = `${this.api.getPeopleCountApi}${this.$route.params.roomNumber}/${callback}?t=${new Date().getTime()}`;
			this.$store
				.dispatch("timing/getPeopleAsync", {
					url: url,
					callback: callback,
				})
				.then((data: any) => {
					this.getLivePeopleCount(data.refreshTime);
				});
		}, parseInt(time || "0"));
	}
	getAllPeople() {
		//获取房间累计人数
		let url = `${this.api.getAllPeopleCountApi}/${this.$route.params.id}?room_id=${this.$route.params.id}&t=${Math.floor(new Date().getTime() / 5000)}`;
		this.fetch({
			url: url,
			data: { room_id: this.$route.params.id },
			method: "GET",
		}).then((data: any) => {
			this.peopleAll = data;
		});
	}
	//下载累计关注人数明细
	download() {
		this.isDownLoad = true
		let url = `${this.api.getDownStatusApi}?room_id=${this.$route.params.id}&t=${Math.floor(new Date().getTime() / 5000)}`;
		this.fetch({
			url: url,
			data: { room_id: this.$route.params.id },
			method: "GET",
		}).then((data: any) => {
			this.isDownLoad = false
			this.downloadData()
		}, (res: any) => {
			if (res.code == '103') {
				setTimeout(() => {
					this.download()
				}, 3000);
			} else {
				this.isDownLoad = false
				this.$toast(res.msg)
			}
		});

	}
	//下载累计关注人数明细数据
	downloadData() {
		let url = `${this.api.getDownDataApi}?room_id=${this.$route.params.id}&t=${Math.floor(new Date().getTime() / 5000)}`;
		window.location.href = url
	}
	getLike() {
		//获取喜欢数
		let callback = "like";
		let url = `${this.api.getLike}/${this.$route.params.roomNumber}/${Math.floor(new Date().getTime() / 5000)}/` + callback + '?t=' + new Date().getTime();

		this.$store
			.dispatch("timing/getLikeAsync", {
				url: url,
				callback: callback,
			})
			.then((res: any) => { });
	}
	recommend(goods: any) {
		if (goods.listHidden != 0) {
			return false;
		}
		//发送推荐商品
		let product_id: any = "";
		if (goods.listId != this.explainGoods.listId) {
			product_id = goods.listId;
		}
		this.fetch({
			url: this.api.recommend,
			data: {
				room_name: this.$route.params.roomNumber,
				product_id: product_id,
			},
			// data:{
			// 	room_id: this.$route.params.roomNumber,
			// 	list_id: product_id,
			// },
		}).then((res: any) => {
			if (product_id) {
				this.explainGoods = goods;
			} else {
				this.explainGoods = {};
			}
		});
	}
	destroyed() {
		clearInterval(this.timeInter);
		clearInterval(this.timeInterMsg);
		clearTimeout(this.timeOutTimer);
	}
	// 中后台设置
	setCoupon() {
		if (!this.isClick) {
			return false
		} else {
			this.isClick = false
			setTimeout(() => {
				this.isClick = true
			}, 3000);
		}
		this.fetch({
			url: this.api.setCoupon,
			data: {
				room_id: this.$route.params.id,
				coupon: this.CouponBatchId,
			},
		})
			.then((res: any) => {
				this.$toast("优惠券添加成功");
				this.setCouponModal = false;
			})
			.catch((res: any) => {
				this.$toast(res.msg);
			});
	}
	setUsq(){//打开优鲜设置弹窗
		this.usqManage = true
	}
	setNotice() {
		this.fetch({
			url: this.api.setNotice,
			data: {
				room_id: this.$route.params.id,
				notice: this.noticeCont,
			},
		})
			.then((res: any) => {
				this.setNoticeModal = false;
				this.$toast("设置成功");
			})
			.catch((res: any) => {
				// switch (res.code) {
				// 	case 100:
				//
				// 	case 10000:
				//
				// 	case 20000:
				// 		this.$toast("主播已下线");
				// 	case 30000:
				//
				if (res.code === "20000") {
					this.$toast("主播已下线");
				}
			});
	}
	getLuckyList() {
		this.fetch({
			url: this.api.getLuckyList + "?room_id=" + this.$route.params.id,
			method: "GET",
			data: {},
		}).then((res: any) => {
			console.log(res);
			this.luckyList = res.lucks;
			this.luckyListModal = true;
		});
	}
	copyText(element: string, modal: string) {
		let obj = document.getElementById(element) as any; //获取input对象
		if (!obj.value) {
			return;
		}
		obj.select(); //选择当前对象
		try {
			if (document.execCommand("Copy")) {
				if (modal == "shareRoom") {
					this.shareRoom = false;
				}
				this.$toast("复制成功！");
			} else {
				this.$toast("复制失败！可以手动复制");
			}
		} catch (err) {
			this.$toast("复制错误！可以手动复制");
		}
	}
	changePlay(type?: number) {
		if (!this.isClick) {
			return false
		} else {
			this.isClick = false
			setTimeout(() => {
				this.isClick = true
			}, 3000);
		}
		jsonp(this.api.changePlay, {
			id: this.$route.params.id,
			tvStatus: type,
			jsonp: "callback",
		}).then((data: any) => {
			if (type === 1) {
				if (!this.isRecording) {
					this.openLive = true;
				}
				this.OBSLink = data.rtmp_url || "";
				this.sshLink = data.rtmp_token || "";
			} else {
				this.$toast("操作成功");
				location.reload();
			}
			this.getRoomDetail();
		}).catch((res: any) => {
			if (res.code == '10001')
				this.$dialog.alert({
					message: '根据相关法律的规定，必须完成实名认证后才能进行直播活动，您可下载邮乐直播APP，在登录页面输入账号密码点击登录即可开启实名认证流程',
					confirmButtonText: "我知道了"
				});
			else
				this.$toast(res.msg);

		});
	}
	//弹窗显示改变
	hintChange(data: any) {
		let m: any = this
		m[data.name] = data.val
	}
	// 自定义分类弹框
	classification() {
		this.fetch({
			url: this.api.goodsCategoryAll + this.roomData.scene_id,
			method: "get"
		}).then((data: any) => {
			this.queryRoomScene((data: any) => {
				this.isClassification = true;
			})
			this.classificationList = data
		})
	}
	// 邀请码弹框弹框
	invitationCode() {
		// this.fetch({
		// 	url: this.api.goodsCategoryAll + this.roomData.scene_id,
		// 	method: "get"
		// }).then((data: any) => {
			// 	this.classificationList = data
			// })
		this.queryRoomScene((data: any) => {
			this.isInvitationCode = true;
		})
	}
	//点击设置分享内容
	uploadShareEvent() {
		this.queryRoomScene((data: any) => {
			this.isShareData = true;
		})
	}
	//点击上传海报事件
	uploadPosterEvent() {
		this.queryRoomScene((data: any) => {
			//重置海报状态及信息
			this.posterUrl = null;
			this.auditStatusText = "提交审核";
			this.posterInfo = null;
			this.uploadInfo = null;//待上传图片
			this.isDesabled = true;
			this.updateRefreshInfo();
			this.isShowPosterSet = true;
		})
	}
	//订单管理
	orderManage() {
		this.queryRoomScene((data: any) => {
			this.isOrderManage = true;
		})
	}
	//秒杀管理
	seckillManage() {
		// this.queryRoomScene((data:any)=>{
		this.isSeckillManage = true;
		// })
	}
	//福袋管理
	blessingBagManage() {
		// this.queryRoomScene((data:any)=>{
		this.isBlessingBagManage = true;
		// })
	}
	//查询是否有未开播,直播中的场次
	queryRoomScene(callback: any) {
		this.fetch({
			url: this.api.roomScene + "?room_id=" + this.$route.params.id,
			method: "get",
		}).then((res: any) => {
			callback(res);
		}).catch((err: any) => {
			this.$toast("你还未创建直播场次，暂不能设置");
		})
	}
	//海报尺寸、大小、格式判断
	beforeRead(file: any, d: any) {
		// console.log('上传的文件信息',file)
		let maxSize = 1 * 1024 * 1024;//最大文件不能超过1M
		//读取上传的图片文件，获取图片尺寸
		let reader: any = new FileReader();
		reader.readAsDataURL(file.file);
		reader.onload = (theFile: any) => {
			let image: any = new Image();
			image.src = theFile.target.result;
			image.onload = () => {
				// console.log(image.width,image.height)
				file.status = 'uploading';
				file.message = '上传中...';
				if (image.width != '750' || image.height != '1350') {
					this.$toast("请上传宽750*高1350的图片");
					return false
				} else {
					if (maxSize < file.file.size) {
						this.$toast("请上传小于1M大小的图片");
						return false
					} else {
						if (file.file.type !== 'image/jpeg') {
							this.$toast("请上传JPG格式的图片");
							return false;
						} else {
							this.uploadInfo = file.file;
							//设置海报地址
							this.posterUrl = file.content;
							this.isDesabled = false;//设置按钮状态为可点击
							this.auditStatusText = "提交审核";
							// this.uploadPoster(file.file);
							return true;
						}
					}
				}
			};
		};
	}
	//上传海报
	uploadPoster(file: any) {
		let params = new FormData();
		params.append("file", file); // 文件对象
		params.append('room_id', this.$route.params.id);  //添加其他参数
		// console.log(params.get("room_id"))
		this.fetch({
			url: this.api.posterSubmit,
			data: params,
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then((res: any) => {
			this.updateRefreshInfo();
			this.isDesabled = true;
			// this.$toast("提交审核成功，邮乐运营同事将尽快完成审核，如若长时间未审核，请联系相关邮乐运营同事");
			this.uploadInfo = null;//重置待上传图片
			this.$dialog
				.alert({
					message: "提交审核成功，邮乐运营同事将尽快完成审核，如若长时间未审核，请联系相关邮乐运营同事",
				})
				.then(() => { });
		}).catch((err: any) => {
			this.$toast("海报上传失败，请重试");
		})
	}
	//海报上传状态过滤
	filterStatus(status: 0) {
		let textArr = ["提交审核", "待审核", "生效中", "审核拒绝"];
		return textArr[status];
	}
	//提交审核
	submitPoster() {
		this.uploadPoster(this.uploadInfo);
	}
	// 刷新推流地址
	refreshtuiliu() {

		this.fetch({
			url: this.api.boomDetailApi + "?room_id=" + this.$route.params.id,
			method: "GET",
		}).then((data: any) => {
			console.log(data)
			this.isShowTuiliu = true
			this.OBSLink = data.rtmp_url || "";
			this.sshLink = data.rtmp_token || "";
		}).then((err: any) => {
			console.log(err)
		});
	}
	// stepChangeDebounceRight:_com.debounce(function(goods:any,action:any){
	// 	let _this = this;
	// 	_this.startFilmed(goods,action)
	// 	_com.debounce()
	// },1000)
	//开始录制视频
	debounceStart(goods: any = {}, action: string) {
		console.log('商品信息', goods, this.explainGoods, action);
		if (this.roomData.live_status != 1 || this.videoStatus.roomStatus != '1') {
			// return this.$toast("您还未开播，无法录制视频");
			return this.$toast({
				message: "您还未开播，无法录制视频",
				position: 'top'
			});
		}
		if (this.explainGoods.listId == goods.listId) {
			//录制视频，正在直播且正在讲解的商品才能录制
			this.filmedControl(action, goods);
		} else {
			this.$toast({
				message: "您还未讲解商品，无法录制/删除视频",
				position: 'top'
			});
		}
		// this.filmedControl(action,goods);
	}
	//视频开始/结束录制
	filmedControl(action: string, goods: any) {
		if(this.stopClick) return
		if(action == '1'){
			this.waitFor =  '请稍等...'
			this.isAshRecording = true
			this.stopClick = true
			setTimeout(()=>{
				this.stopClick = false
				this.recordingStatus(action,goods)
			},3000)
		}else if(action == '2'){
			this.waitFor =  '视频录制'
			this.filmedText = '录制完成'
			clearTimeout(this.timeOutTimer);
			this.isAshRecording = true
			this.stopClick = true
			setTimeout(()=>{
				this.stopClick = false
				this.recordingStatus(action,goods)
			},3000)
		}else if(action == '3'){
			// this.isAshRecording = true
			this.waitFor = '视频录制'
			this.recordingStatus(action,goods)
		}
	}
	recordingStatus(action: string, goods: any):void{  // 录制状态处理
		this.fetch({
			url: this.api.goodRecord,
			data: {
				room_id: this.$route.params.id,
				list_id: goods.listId,//商品ID
				action: action//1 – 开始录制 2 – 结束录制 3-删除
			},
			method: "post",
		}).then((data: any) => {
			this.updateRefreshInfo();//查询商品列表信息
			if (action === '1') {
				clearTimeout(this.timeOutTimer);
				//开始录制成功
				this.isAshRecording = false
				this.filmedText = "00:00:00";//每次重新开始录制重置时间显示
				this.timeOutText(goods, 0);//倒计时显示
			} else if (action === '2') {
				//结束录制成功
				this.isAshRecording = false
				this.filmedText = "删除录制视频";
				// this.$toast("直播讲解录制成功");
				this.$toast({
					message: "直播讲解录制成功",
					position: 'top'
				});
			} else if (action === '3') {
				//删除录制视频成功
				// this.$toast("直播讲解删除成功");
				this.waitFor == ''
				this.$toast({
					message: "直播讲解删除成功",
					position: 'top'
				});
			}
		}).catch((err: any) => {
			console.log('开始/结束录制失败', err);
			this.isAshRecording = false
			this.$toast({
				message: err.data,
				position: 'top'
			});
			clearTimeout(this.timeOutTimer);
		});
	}
	timeOutText(goods: any, filemdTime: number = 0) {
		this.timeOutTimer = setTimeout(() => {
			// this.filemdTime++;
			filemdTime++;
			if (filemdTime > 180) {
				//录制时间到180秒就结束计时
				clearTimeout(this.timeOutTimer);
				this.filmedText = "删除录制视频";
			} else {
				this.timeOutText(goods, filemdTime);
				this.filmedText = this.formatSeconds(filemdTime);
			}
		}, 1000);
	}
	//秒数转化为时分秒
	formatSeconds(value: any = 0) {
		let h: any = value / 3600;
		let m: any = (value % 3600) / 60;
		let s: any = ((value % 3600) % 60);
		let hh: any = parseInt(h) >= 10 ? parseInt(h) : '0' + parseInt(h);
		let mm: any = parseInt(m) >= 10 ? parseInt(m) : '0' + parseInt(m);
		let ss: any = parseInt(s) >= 10 ? parseInt(s) : '0' + parseInt(s);
		let result = hh + ':' + mm + ':' + ss;
		return result;
	}

	//设置红包雨活动code
	seHbHandler() {
		let code = this.setHbCode.replace(/\s+/g, '');
		this.setHbCode = code;
		if (!code) {
			this.$toast("请输入红包雨活动code");
			return false;
		}
		jsonp(this.api.redRainOpen + `/${this.$route.params.id}/${code}/callback`, {
			room_id: this.$route.params.id,
			code: code,
			jsonp: "callback",
			jsonpcallback: 'callback'
		}).then((data: any) => {
			// console.log(data)
			this.$toast("红包雨开启成功");
			this.setHbModal = false;
		}).catch(err => {
			// console.log(err);
			this.$toast(err.data || "红包雨开启失败，请重试");
		})
	}
	//跳转数据看板
	toDataBroad() {
		let url = `https://opc${this.domain}/dashboard/2020/broadlive?id=${this.$route.params.id}`;
		let windowReference: any = window.open();
		windowReference.location = url;
		windowReference.opener = null;//防止通过 window.opener 获取原窗口的引用，利用这个引用，可以修改原窗口的属性
	}

	initLottoryFree() {
		//查询当日抽奖信息
		this.fetch({
			url: this.api.lotteryDaily,
			data: {},
			method: "get",
		}).then((data: any) => {
			let nowTimes = new Date().getTime();
			nowTimes = nowTimes + this.difference;
			let startTime = new Date(data.startTime).getTime()
			this.isShowLottoryFree = data && this.$route.params.roomNumber == data.roomCode;
			this.lottoryFreeInfo = { ...data, ...{ startTime, nowTimes } };
			if (this.isShowLottoryFree) {
				this.freeNums = data.prizeQty;
			}
		}).catch((err: any) => {
			console.log(err);
			this.$toast(err.data || "抽奖信息查询失败，请重试");
		});
	}
	//设置抽免单
	toFreeOrder() {
		this.fetch({
			url: `${this.api.lotteryFire}?revision=${this.lottoryFreeInfo.revision || ''}`,
			data: {
				// revision:this.lottoryFreeInfo.revision||''
			},
			method: "get",
		}).then((data: any) => {
			this.freeNums = '';
			this.setFreeModal = false;
			this.$toast("设置抽免单成功");
			this.initLottoryFree();
		}).catch((err: any) => {
			console.log(err);
			this.$toast(err.data || "设置抽免单失败，请重试");
		});
	}
	numberFormatter(val: any) {
		val = val ? Number(val) : val
		if (!val && val != '') {
			val = 1
		}
		this.freeNums = val
	}
	showFreeModel() {
		this.setFreeModal = true;
		this.initLottoryFree();
	}
	//劳务招聘点击事件
	getJob(){
		console.log('======')
		// this.isGetJob=true;
	}
}
